import React from 'react';

const Footer = () => {
    return (
        <footer className='bg-black h-10 flex justify-center items-center'>
            <p className='text-gray-400'><small>Copyright © 2022</small></p>

        </footer>
    );
};

export default Footer;